import React from 'react';
import './AboutUs.css'; // Make sure to import your CSS file

const AboutUs = () => {
    return (
        <main className="about-us">
            <section className="introduction">
                <h1>Welcome to Maxfort School: Where Excellence Thrives</h1>
                <p>At Maxfort School, we take pride in being one of the premier educational institutions in our town. With a legacy of excellence and a commitment to nurturing young minds, we have established ourselves as a beacon of quality education and academic achievement.</p>
            </section>
            <section className="excellence-tradition">
                <h2>A Tradition of Excellence</h2>
                <p>Maxfort School has long been synonymous with academic excellence and outstanding results in board examinations. Our dedication to providing top-notch education, coupled with the hard work and determination of our students, has consistently resulted in stellar performance, with many achieving a 100 percent pass rate in board exams.</p>
            </section>
            <section className="teaching-staff">
                <h2>Exceptional Teaching Staff</h2>
                <p>Central to our success is our exceptional teaching staff, who are not just educators but mentors and guides. With their expertise, passion for teaching, and dedication to student success, they inspire and empower our students to reach their full potential academically, socially, and personally.</p>
            </section>
            <section className="holistic-development">
                <h2>Holistic Development</h2>
                <p>At Maxfort School, we believe in nurturing well-rounded individuals. Alongside academic rigor, we place a strong emphasis on holistic development, encouraging students to explore their interests, develop critical thinking skills, and cultivate a lifelong love of learning.</p>
            </section>
            <section className="learning-community">
                <h2>A Vibrant Learning Community</h2>
                <p>Beyond academics, Maxfort School is a vibrant learning community where students thrive. Our engaging extracurricular activities, sports programs, and cultural events provide ample opportunities for students to discover their passions, build confidence, and forge lifelong friendships.</p>
            </section>
            <section className="commitment">
                <h2>Our Commitment</h2>
                <p>Our commitment to excellence, innovation, and continuous improvement drives everything we do at Maxfort School. We are dedicated to providing a supportive and enriching environment where every student can flourish and achieve their goals.</p>
            </section>
            <section className="join-us">
                <h2>Join Us</h2>
                <p>Whether you are a prospective student, parent, or member of our community, we invite you to join us on this journey of learning, growth, and discovery at Maxfort School. Together, let's shape a brighter future.</p>
                <p>Welcome to Maxfort School, where every child's potential is realized, and dreams are turned into reality.</p>
            </section>
        </main>
    );
}

export default AboutUs;
